module.exports = __webpack_public_path__ + "static/media/logo_portal_self.90d830da.png";